import { cn } from 'shared-components';
import { type FunctionComponent } from 'react';

import { type PageTitleProps } from './PageTitle.types';

const PageTitle: FunctionComponent<PageTitleProps> = ({ children, className }) => (
  <h1 className={cn('mt-5 mb-6 text-center text-2xl font-semibold m:text-left m:text-[2rem]', className)}>
    <span
      className={cn(
        "relative inline-block max-w-full after:relative after:left-1/4 after:mt-1.25 after:block after:h-1 after:w-1/2 after:bg-[#191919] after:content-[''] m:after:static",
      )}
    >
      {children}
    </span>
  </h1>
);

PageTitle.displayName = 'PageTitle';

export { PageTitle };
